import { useEffect, useState } from "react";
import styles from "./lastvideo.module.css";
import { useNavigate } from "react-router-dom";
import ImageOverlay from "../ImageOverLay/ImageOverlay";
import VideoModal from "../VideoModal/VideoModal";
import { videosLogic } from '../../../Logic/Videos';
import { statisticsLogic } from "../../../Logic/Statistics";


export default function LastVideo() {

    const navigate = useNavigate();
    const [video, setVideo] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [viewVideo, setViewVideo] = useState<boolean>(false);
    const [usuario, setUsuario] = useState<{ nombre: string; email: string } | null>(null);
    const [sessionID, setSessionID] = useState("");


   function playVideo () {

    setViewVideo(true);

    //get user name 
    var userName = usuario != null ? usuario.nombre : "Unknown - "+ sessionID
    statisticsLogic.RegisterStat({"Nombre":userName, "Funcionalidad":"Play Last Video" , "Valor": "null"})


    }


    //get session & user registered if exist 
    useEffect(() =>{
      const data = localStorage.getItem("usuarioRegistrado");
      const session = localStorage.getItem("c7_sessionID");
    
      if (data) {
        const usuarioRegistrado = JSON.parse(data);
        setUsuario(usuarioRegistrado);
      }

      if(session){
        setSessionID(session)
      }

    },[])

    useEffect(() => {

      const getLastVideo = async () => {

        const lastVideo = await videosLogic.GetLastVideoUploaded().catch(error => {})

        if (lastVideo) {
          setVideo(lastVideo.video); 
        } else {
          setError('Hubo un error al recuperar el video. Intenta de nuevo mas tarde');
        }

      }

        try {
          getLastVideo()

        } catch (error) {
          setError('Hubo un error al recuperar el video. Intenta de nuevo mas tarde');
        }
    }, []);

 
  
    return (
        <>
        <h1 className={styles.titleSection}>Última prédica</h1>
      <div className={styles.container}>
        {error && <p>{error}</p>}
        {video ? (<>
            <ImageOverlay
                src={video.thumbnail}
                alt={video.title}
                text="Reproducir"
                onClick={() => playVideo() }
          />
            <div className={styles.button} onClick={() =>navigate("/predicas")}>
                MÁS PRÉDICAS
            </div>
        </>
        ) : (
           error ? null : <p>Cargando video...</p>
        )}
      </div>

      {/* Modal para reproducir el video */}
      {viewVideo && <VideoModal videoId={videosLogic.GetYouTubeVideoIdFromUrl(video.url)} onClick={() => setViewVideo(false) }></VideoModal>}

    </>
     
    );
}